/**
 *
 * AdministratorForm14852
 *
 */

import ReceptionForm14852 from '../ReceptionView/ReceptionForm14852';


export class AdministratorForm14852 extends ReceptionForm14852 {
}
